import { ModelFactory } from '@leverege/ui-plugin';
import { ns } from '@leverege/i18n';
import StreamingExportFormatter from "./StreamingExportFormatter.js";
import Model from "./JSONExportFormatterModel.js";
import Util from "./Util.js";
const {
  t
} = ns('ui-attributes.export.JSONExportFormatter');
class JSONExportFormatter extends StreamingExportFormatter {
  constructor(...rest) {
    super(...rest);
    this.hasWritten = false;
  }
  writeData(data, fields) {
    const docs = this.getJSONDocuments(data, fields);
    this.hasWritten = true;
    return this.writer.write(this.textEncoder.encode(docs));
  }
  getJSONDocuments(items, fields) {
    const newline = Model.getNewline(this.model);
    return items.reduce((prev, curr, index) => {
      const needsComma = this.hasWritten || index !== 0;
      return `${prev}${needsComma ? ',' : ''}${this.getJSONDocument(curr, fields)}${newline ? '\n' : ''}`;
    }, '');
  }
  getJSONDocument(item, fields) {
    const space = Model.getSpace(this.model);
    return JSON.stringify(fields.reduce((prev, field, index) => {
      const attr = Util.getAttributeForField(field);
      const model = ModelFactory.get(field);
      const value = attr.get(item.data);
      const formatted = model.renderText(value, field);
      const key = model.getHeaderLabel(field) || attr?.displayName || t('header', {
        index: index + 1
      });
      return {
        ...prev,
        [key]: formatted
      };
    }, {}), null, space);
  }
  init() {
    const newline = Model.getNewline(this.model);
    this.writer.write(this.textEncoder.encode(`[${newline ? '\n' : ''}`));
  }
  end() {
    this.writer.write(this.textEncoder.encode(']'));
    super.end();
  }
}
export default JSONExportFormatter;